import { useContext, useState } from 'react'
import { useFormik } from 'formik';
import * as Yup from "yup";
import { UserInfo, initialuserInfo } from '../../../../../../types/types'
import { StartUpStepperContext } from '../../StartUpStepperContext';
import { useNavigate } from 'react-router-dom';
//import { phone_regex } from '../../../../../../../shared/const';
import YupPassword from 'yup-password'
import clsx from 'clsx';
import { Logo } from '../../../../../../atoms';
import { StepperHeader } from '../../../sharedComponents';
import useMediaQuery from '../../../../../../../hook/useMediaQuery';
import { MediaTablet } from '../../../../../../../api/const/MediaQuery';
import './StepperStartUp.css'
import { emailRegex } from 'shared/const';
YupPassword(Yup)

const userInfoSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(3, 'Too Short!, min 3 char')
    .max(70, 'Too Long!, max 70 char')
    .required('Please complete this required field.'),
  lastName: Yup.string()
    .min(3, 'Too Short!, min 3 char')
    .max(70, 'Too Long!, max 70 char')
    .required('Please complete this required field.'),
  email: Yup.string()
  .matches(emailRegex, 'Wrong email format')
  .required('Please complete this required field.'),
  phoneNumber: Yup.string()
    //.matches(phone_regex, 'Phone number not correct')
    .required('Please complete this required field.'),
  password: Yup.string().password()
    .min(8, 'Password must contain 8 or more characters with at least one of each: uppercase, lowercase, number and special')
    .minLowercase(1, 'Password must contain at least 1 lower case letter')
    .minUppercase(1, 'Password must contain at least 1 upper case letter')
    .minNumbers(1, 'Password must contain at least 1 number')
    .minSymbols(1, 'Password must contain at least 1 special character')
    .required('Please complete this required field.'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords doesn\'t match')
    .required('Please complete this required field.'),
});

export const StepUserInfo = (props: any) => {
  const navigate = useNavigate();
  const tablet = useMediaQuery(MediaTablet)
  const ctx = useContext(StartUpStepperContext)

  const [userInfo] = useState<UserInfo>({
    ...initialuserInfo
  })

  const formik = useFormik<UserInfo>({
    initialValues: userInfo,
    validationSchema: userInfoSchema,
    onSubmit: async (values, { setSubmitting }) => {
      // setSubmitting(true)

      ctx.setFirstName(values.firstName)
      ctx.setLastName(values.lastName)
      ctx.setEmail(values.email)
      ctx.setPhoneNumber(values.phoneNumber ?? "")
      ctx.setPassword(values.password)
      ctx.setConfirmPassword(values.confirmPassword)

      props.nextStep()
    }
  })


  return (
    <div
      className={clsx(
        'pe-3 mt-3',
        { 'd-none': !props.isActive },
      
      )} >
      <StepperHeader stepperTitle='User Info' />

      <form onSubmit={formik.handleSubmit} autoComplete='off'>

        {/* firstName*/}
        <label className='text-black mt-3' htmlFor="firstName">First Name<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
        <input
          autoComplete="new-password"
          placeholder='First Name'
          {...formik.getFieldProps('firstName')}
          className="form-input"
          type="text"
          onChange={formik.handleChange}
          onBlur={() => formik.setFieldTouched("firstName", true)}
          value={formik.values.firstName}
          name="firstName"
        />
        {formik.errors.firstName && formik.touched.firstName && <div className='text-error' id="firstName">{formik.errors.firstName}</div>}

        {/* lastName */}
        <label className='text-black mt-3' htmlFor="lastName">Last Name<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
        <input
          autoComplete="new-password"
          placeholder='Last Name'
          {...formik.getFieldProps('lastName')}
          className="form-input"
          type="text"
          onChange={formik.handleChange}
          onBlur={() => formik.setFieldTouched("lastName", true)}
          value={formik.values.lastName}
          name="lastName"
        />
        {formik.errors.lastName && formik.touched.lastName && <div className='text-error' id="lastName">{formik.errors.lastName}</div>}
      
       {/* phoneNumber */}
        <label className='text-black mt-3' htmlFor="phoneNumber">Mobile Phone Number<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
        <input
          autoComplete="new-password"
          placeholder='Your mobile phone number'
          {...formik.getFieldProps('phoneNumber')}
          className="form-input"
          type="tel"
          onChange={formik.handleChange}
          onBlur={() => formik.setFieldTouched("phoneNumber", true)}
          value={formik.values.phoneNumber}
          name="phoneNumber"
        />
        {formik.errors.phoneNumber && formik.touched.phoneNumber && <div className='text-error' id="phoneNumber">{formik.errors.phoneNumber}</div>}

        {/* email */}
        <label className='text-black mt-3' htmlFor="email">Company e-mail<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
        <input
          autoComplete="new-password"
          placeholder='Company e-mail'
          {...formik.getFieldProps('email')}
          className="form-input"
          type="text"
          onChange={formik.handleChange}
          onBlur={() => formik.setFieldTouched("email", true)}
          value={formik.values.email}
          name="email"
        />
        {formik.errors.email && formik.touched.email && <div className='text-error' id="email">{formik.errors.email}</div>}


        {/* password */}
        <label className='text-black mt-3' htmlFor="password">Password<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
        <input
          autoComplete='(suggested: "new-password")'
          placeholder='Password'
          {...formik.getFieldProps('password')}
          className="form-input"
          type="password"
          onChange={formik.handleChange}
          onBlur={() => formik.setFieldTouched("password", true)}
          value={formik.values.password}
          name="password"
        />
        {formik.errors.password && formik.touched.password && <div className='text-error' id="password">{formik.errors.password}</div>}

        {/* confirmPassword */}
        <label className='text-black mt-3' htmlFor="confirmPassword">Confirm Password<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
        <input
          autoComplete="new-password"
          placeholder='Confirm password'
          {...formik.getFieldProps('confirmPassword')}
          className="form-input"
          type="password"
          onChange={formik.handleChange}
          onBlur={() => formik.setFieldTouched("confirmPassword", true)}
          value={formik.values.confirmPassword}
          name="confirmPassword"
        />
        {formik.errors.confirmPassword && formik.touched.confirmPassword && <div className='text-error' id="confirmPassword">{formik.errors.confirmPassword}</div>}

        <div className="d-flex flex-row justify-content-between mt-4 mb-4  stepper_navigator">
          <button className="w-100 d-flex stepper_navigator_btn justify-content-start  align-items-center "
            onClick={() => { navigate("/getStarted") }} >
            <Logo className="w-20 first me-2 rotate-180 " colorLogo="#FF3F6B" />
            <span> Back </span>
          </button>
          <div className="ms-5 me-5" />
          <button className={clsx(" w-100 d-flex stepper_navigator_btn justify-content-end align-items-center ",
            { "btn-disabled": formik.isSubmitting || !formik.isValid || !formik.touched })}
            disabled={
              formik.isSubmitting
              || !formik.isValid
              || !formik.touched
            }
            type='submit'
          >
            <span>Next</span>
            <Logo className="w-20 first ms-2" colorLogo={"#FF3F6B"} />
          </button>
        </div>
        {/* <button onClick={()=>props.goToStep(3)}>go to step 3</button> */}

      </form >
    </div>
  )
}

